import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menu-link-relation`, payload);
};

const update = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menu-link-relation`, payload);
};

export default {
	list,
	update,
};
